<template>
  <div>
    <div v-if="userInfo && userInfo.user">
      <StudentHeader v-if="this.userInfo.user.permission == 'student'" />
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <div class="w-full">
      <div
        class="container mx-auto max-w-[1200px]"
        style="min-height: 70vh !important"
      >
        <div class="py-10 px-6" v-if="notificationIndex == null">
          <div class="font-bold text-xl pb-3 flex items-center gap-2">
            Messages
            <p
              class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
              v-if="total_count != 0"
            >
              {{ total_count }}
            </p>
          </div>
          <div class="flex flex-col gap-2">
            <div
              v-if="this.messageList.length != 0"
              class="mt-2 flex flex-col gap-4"
            >
              <div v-for="(message, index) in this.messageList" :key="index">
                <div
                  class="flex justify-between border-2 gap-4 py-4 px-5 rounded-xl cursor-pointer hover:bg-slate-100"
                  @click="handleMessageClick(message)"
                >
                  <div class="flex items-center gap-6 w-full">
                    <img
                      v-if="message.readed == true"
                      src="@/assets/newd/Vector(2).svg"
                      class="w-4 h-4"
                      alt=""
                    />

                    <img
                      v-else
                      src="@/assets/newd/Group(1).svg"
                      class="w-4 h-4"
                      alt=""
                    />
                    <div class="flex flex-col gap-1">
                      <p
                        class="text-sm"
                        :class="{
                          'font-bold  ': message.readed !== true,
                          'font-normal ': message.readed === true,
                        }"
                      >
                        <span class="font-bold">Title : </span
                        >{{ message.course_title || "No title" }}
                      </p>

                      <p
                        class="text-sm"
                        :class="{
                          'font-bold  ': message.readed !== true,
                          'font-normal ': message.readed === true,
                        }"
                      >
                        <span class="font-bold"> Semester : </span>
                        {{ message.semester || "NA" }}
                      </p>

                      <p
                        class="text-sm"
                        :class="{
                          'font-bold  ': message.readed !== true,
                          'font-normal ': message.readed === true,
                        }"
                      >
                        <span class="font-bold"> Text : </span>
                        {{ message.text || "NA" }}
                      </p>
                    </div>
                  </div>

                  <p class="text-sm flex justify-end whitespace-nowrap">
                    {{ formatDateTime(message.created_at) }}
                  </p>
                </div>
              </div>
            </div>
            <p
              v-if="this.messageList.length == 0"
              class="flex flex-col border-2 gap-1 py-4 px-5 rounded-xl cursor-pointer"
            >
              No Messages
            </p>
          </div>
          <div
            v-if="messageList.length > 0"
            class="flex justify-center py-4 space-x-2"
          >
            <!-- <Pagination  /> -->

            <Pagination :totalPages="totalPages" @page-changed="loadMessages" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import Footer from "@/components/Footer.vue";
import StudentHeader from "@/components/Student/Header.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Notifications",

  components: {
    StudentHeader,
    Footer,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
  },

  data() {
    return {
      messageList: [],
      notificationIndex: null,
      selectNotificationData: "",
      notifyprocess: [],
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
    };
  },

  computed: {
    ...mapGetters(["userInfo", "messageCount"]),
  },

  created() {},

  mounted() {
    this.$store.dispatch("connectMessageSocket");
    this.$store.commit("SET_ON_NEW_MESSAGE", () => {
      this.loadMessages(this.currentPage);
    });
    this.loadMessages();
  },

  methods: {
    async loadMessages(page = 1) {
      if (!this.userInfo) return;
      const data = await this.$store.dispatch("fetchMessageList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.messageList = data.data;
      console.log("test/////////////////000000", this.messageList);
      this.currentPage = data.current_page;
      this.totalPages = data.total_page;
      this.total_count = data.total;
    },

    formatDateTime(dateString) {
      const date = new Date(dateString);
      const now = new Date();

      const isSameDate =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

      if (isSameDate) {
        // Show only time if today
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } else {
        // Show full date and time if not today
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }
    },

    // async getMessages(page) {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.userInfo.user.id}&Key=${this.userInfo.token_key}&page=${page}`
    //     )
    //     .then((response) => {
    //       if (response) {
    //         // this.notifyCount(response.data.count);
    //         this.totalPages = response.data.data.total_page;
    //         this.messageList = response.data.data.data;
    //         this.total_count = response.data.data.total;
    //         console.log("total_count", this.total_count);
    //         console.log("notificationList", this.messageList);
    //       }
    //     });
    // },

    handleMessageClick(message) {
      console.log("dsfsdsdf", message.id);
      console.log("dsfsdsdf", message.client_department_id);

      let formdata = {
        readed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/message-read-update/${message.id}/?Key=${this.userInfo.token_key}`,
          formdata
        )
        .then((response) => {
          if (response.data.status === 200) {
            if (message.course_id || message.client_department_id) {
              if (this.userInfo.user.permission == "student") {
                this.$router.push(
                  `/student/dashboard/${message.course_id}/newmessages`
                );
              } else if (
                this.userInfo.user.permission == "super_admin" ||
                this.userInfo.user.permission == "co-ordinator" ||
                this.userInfo.user.permission == "hod" ||
                this.userInfo.user.permission == "instructor"
              ) {
                this.$router.push(
                  `/course/dashboard/${message.course_id}/${message.client_department_id}/newmessages`
                );
              }
            } else {
              console.warn("No course_id in message. Navigation skipped.");
            }
          }
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
